import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';
import AppService from 'App/legacy/AppService';

export default function updateActivities(rb: RequestBuilder, entity: string, multiSelect: MultiSelect) {
	return new Promise((resolve, reject) => {
		openModal('MultiUpdateActivity', {
			customerId: AppService.getCustomerId(),
			filters: rb,
			entity,
			multiSelect,
			onClose: (res: any) => {
				if (res === undefined) return reject();
				resolve(res);
			}
		} as any);
	});
}
